module.exports = __webpack_public_path__ + "img/img-03.aad3bd77.png";